import React, { useState, useEffect } from "react";
import { TableSortLabel } from "@mui/material";
import {
  Menu,
  FormGroup
} from "@mui/material";

import {
  Box, Typography, TextField, Table, TableHead, TableRow,
  TableCell, TableBody, Grid, Button, Pagination, Stack, Select, MenuItem
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
// import { managepolicyallAction } from "../../../redux/actions/dashboardAction";
import { searchPolicyAction } from "../../../redux/actions/dashboardAction";
import DatePickerField from '../../../common/DatePickerDashboard';
import { FormControlLabel } from "@mui/material";
import { Checkbox } from "@mui/material";
import { useTheme, useMediaQuery } from '@mui/material';
import NoDataFound from "../../../common/NoDataFound";
import NoSearchResults from "../../../common/helpers/NoSearchResults";

const searchOptions = [
  { label: "Policy Number", value: "policyNumber" },
  { label: "Name", value: "name" },
  { label: "Email", value: "emailId" },
  { label: "Phone Number", value: "phoneNumber" },
  { label: "VIN", value: "vin" },
  { label: "Status", value: "status" },
  { label: "Policy Type", value: "policyType" },
  { label: "Company", value: "company" },
  { label: "Line of Business", value: "lineOfBusiness" },
  { label: "Premium", value: "premium" },
];


const PolicyList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  // const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  // const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const [searchField, setSearchField] = useState("policyNumber");
  const [searchValue, setSearchValue] = useState("");
  const [isSearchMode, setIsSearchMode] = useState(false);
  // const [lastSearchPayload, setLastSearchPayload] = useState(null);
  const [sortField, setSortField] = useState("policyNumber");
  const [sortOrder, setSortOrder] = useState("asc");
  const [hasSearched, setHasSearched] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const initialFormData = {
    fromDate: "",
    toDate: "",
  };

  const [formData, setFormData] = useState(initialFormData);

  const [fieldErrors, setFieldErrors] = useState({});
  const [touchedFields, setTouchedFields] = useState({});

  const selectedFieldLabel = searchOptions.find(opt => opt.value === searchField)?.label || "";

  const policyList = useSelector((state) => state.dashboardData?.manage_policy_all?.content || []);
  const pagination = useSelector((state) => state.dashboardData?.manage_policy_all);

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const defaultVisibleCols = {
    policyNumber: true,
    company: true,
    effectiveDate: true,
    expirationDate: true,
    status: true,
    lineOfBusiness: true,
    policyType: true,
    name: true,
    emailId: true,
    phoneNumber: true,
    state: true,
    premium: true,
  };

  const [visibleCols, setVisibleCols] = useState(defaultVisibleCols);
  const handleDateChange = (fieldName, value) => {
    setFormData((prev) => ({ ...prev, [fieldName]: value }));
  };

  const handleBlur = (fieldName, errorMsg) => {
    setTouchedFields((prev) => ({ ...prev, [fieldName]: true }));
    setFieldErrors((prev) => ({ ...prev, [fieldName]: errorMsg }));
  };

  const handleRowClick = (rowData) => {
    const formattedData = {
      id: rowData.id,
      firstName: rowData.firstName || "",
      middleName: rowData.middleName || null,
      lastName: rowData.lastName || "",
      email: rowData.emailId || null,
      policyNumber: rowData.policyNumber,
      policyType: rowData.policyType,
      dateOfBirth: null,
      phoneNumber: rowData.phoneNumber,
      company: rowData.company,
      licenseNumber: null,
      effectiveDate: rowData.effectiveDate,
      expiryDate: rowData.expirationDate,
      status: rowData.status,
      lineOfBusiness: rowData.lineOfBusiness,
      premium: rowData.premium,
    };
    
    navigate("/globalsearch", {
      state: {
        id: formattedData.id,
        showPolicyDetails: true,
        clientCustomerId: rowData.clientCustomerId,
        selectedPolicyData: rowData,
      },
    });
    dispatch({ type: "CLEAR_GET_CLIENT_SUCCESS" });
    dispatch({ type: "CLEAR_GET_CUSTOMER_DETAILS_SUCCESS" });
    dispatch({ type: "CLEAR_CUSTOMER_SEARCH_LIST_SUCCESS" });
  };

  const handleSort = (field) => {
    const isAsc = sortField === field && sortOrder === "asc";
    setSortOrder(isAsc ? "desc" : "asc");
    setSortField(field);
    setCurrentPage(1);
  };

  const isColumnMenuOpen = Boolean(anchorEl);

  const handleColumnMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleColumnMenuClose = () => {
    setAnchorEl(null);
  };


useEffect(() => {
    if (isSearchMode) {
      const payload = {
        [searchField]: searchValue,
        ...(formData.fromDate && { fromDate: formData.fromDate }),
        ...(formData.toDate && { toDate: formData.toDate }),
      };
    dispatch(searchPolicyAction(payload, currentPage - 1, rowsPerPage, sortField, sortOrder));

  }
    //  else {
    //   fetchData(currentPage, rowsPerPage, sortField, sortOrder);
    // }
  }, [currentPage, rowsPerPage, sortField, sortOrder]);

  // const fetchData = (page, size, sortField = "policyNumber", sortOrder = "asc") => {
  //   dispatch(managepolicyallAction(page - 1, size, sortField, sortOrder));
  // };

  const handleFilter = () => {
    let sanitizedValue = searchValue;
    if (searchField === "phoneNumber") {
      sanitizedValue = sanitizedValue.replace(/[^\d]/g, "");
    }

    const payload = {
      [searchField]: sanitizedValue?.trim(),
      ...(formData.fromDate && { fromDate: formData.fromDate }),
      ...(formData.toDate && { toDate: formData.toDate }),
    };

    setIsSearchMode(true);
    // setLastSearchPayload(payload);
    setCurrentPage(1);
    setHasSearched(true);
    dispatch(searchPolicyAction(payload, 0, rowsPerPage, sortField, sortOrder));
  };

  const handleReset = () => {
    setSearchValue("");
    setSearchField("policyNumber");
    setFormData({ fromDate: null, toDate: null });
    setTouchedFields({});
    setFieldErrors({});
    setCurrentPage(1);
    setIsSearchMode(false);
    // setLastSearchPayload(null);
    setHasSearched(false);
    dispatch({ type: "RESET_POLICY" });
  };

  const formatPhoneNumber = (phone) => {
    if (!phone) return '';

    let cleaned = phone.replace(/\D/g, '');

    if (cleaned.length === 11 && cleaned.startsWith('1')) {
      cleaned = cleaned.substring(1);
    }

    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    return match ? `${match[1]}-${match[2]}-${match[3]}` : phone;
  };

  return (
    <Box sx={{ padding: isMobile ? "20px 15px" : "20px 50px" }}>
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'flex-start',
        marginBottom: 2,
        flexDirection: isMobile ? 'column' : 'row',
        gap: isMobile ? 2 : 0
      }}>
        <Typography variant="h2" fontWeight="bold" gutterBottom={isMobile}>
          Policy List
        </Typography>
        
        <Button
          variant="outlined"
          onClick={handleColumnMenuOpen}
        >
          Select Columns
        </Button>

        <Menu
          anchorEl={anchorEl}
          open={isColumnMenuOpen}
          onClose={handleColumnMenuClose}
          MenuListProps={{
            sx: { padding: 1, maxHeight: 400, minWidth: 200 },
          }}
          anchorOrigin={{ 
            vertical: 'bottom', 
            horizontal: isMobile ? 'left' : 'right' 
          }}
          transformOrigin={{ 
            vertical: 'top', 
            horizontal: isMobile ? 'left' : 'right' 
          }}
        >
          <FormGroup sx={{ padding: '0 12px' }}>
            {Object.entries(visibleCols).map(([key, value]) => (
              <FormControlLabel
                key={key}
                control={
                  <Checkbox
                    checked={value}
                    onChange={() =>
                      setVisibleCols((prev) => ({ ...prev, [key]: !prev[key] }))
                    }
                  />
                }
                label={key
                  .replace(/([A-Z])/g, ' $1')
                  .replace(/^./, str => str.toUpperCase())}
              />
            ))}
          </FormGroup>
        </Menu>
      </Box>

      {/* Filters */}
      <Box mb={3} p={2} sx={{ border: '1px solid #e0e0e0', borderRadius: '8px' }}>
        <Grid container spacing={2} sx={{ marginBottom: "15px", alignItems: 'flex-start' }}>
          {/* Search Field */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="body2">Search Field</Typography>
            <Select
              fullWidth
              size={isMobile ? "small" : "medium"}
              value={searchField}
              onChange={(e) => setSearchField(e.target.value)}
              sx={{
                height: '55px',
                '& .MuiSelect-select': {
                  display: 'flex',
                  alignItems: 'center',
                  height: '100% !important'
                }
              }}
            >
              {searchOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
  </Grid>

  <Grid item xs={12} sm={6} md={2}>
            <Typography variant="body2">{`Search ${selectedFieldLabel}`}</Typography>
            <TextField
              fullWidth
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              placeholder={`Enter ${selectedFieldLabel}`}
              size={isMobile ? "small" : "medium"}
              sx={{
                height: '55px',
                '& .MuiInputBase-root': {
                  height: '100%'
                }
              }}
            />
          </Grid>


          <Grid item xs={12} sm={6} md={2} sx={{ minHeight: '85px' }}>
            <Typography variant="body2">From Date</Typography>
            <DatePickerField
              placeholder="MM/DD/YYYY"
              fieldName="fromDate"
              formData={formData}
              handleDateChange={handleDateChange}
              handleBlur={handleBlur}
              touchedFields={touchedFields}
              fieldErrors={fieldErrors}
              size={isMobile ? "small" : "medium"}
              sx={{
                '& .MuiInputBase-root': {
                  height: isMobile ? '40px' : '55px'
                }
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={2} sx={{ minHeight: '85px' }}>
            <Typography variant="body2">To Date</Typography>
            <DatePickerField
              placeholder="MM/DD/YYYY"
              fieldName="toDate"
              formData={formData}
              handleDateChange={handleDateChange}
              handleBlur={handleBlur}
              touchedFields={touchedFields}
              fieldErrors={fieldErrors}
              size={isMobile ? "small" : "medium"}
              sx={{
                '& .MuiInputBase-root': {
                  height: isMobile ? '40px' : '55px'
                }
              }}
            />
          </Grid>

  <Grid item xs={12} sm={6} md={2} sx={{ display: 'flex', gap: 2, minHeight: '85px', alignItems: 'flex-end', marginTop: '7px' }}>
    <Button
      variant="contained"
      onClick={handleFilter}
      fullWidth={isMobile}
    >
      Filter
    </Button>
    <Button
      variant="outlined"
      onClick={handleReset}
      fullWidth={isMobile}
    >
      Reset
    </Button>
  </Grid>
        </Grid>
      </Box>

      {/* Table */}
      <Box sx={{ width: '100%', overflowX: 'auto' }}>
        {!hasSearched ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '200px',
              backgroundColor: '#f9f9f9',
              borderRadius: 2,
              border: '1px solid #e0e0e0',
            }}
          >
          <NoDataFound
            discription="Please use the filters above to fetch and display policy data."
          />
          </Box>
        ) : (
          <Table size="small" sx={{ minWidth: isMobile ? '800px' : '100%' }}>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#F6C21E' }}>
                {visibleCols.policyNumber && (
                  <TableCell sx={{ fontWeight: "bold" }} sortDirection={sortField === "policyNumber" ? sortOrder : false}>
                    <TableSortLabel
                      active={sortField === "policyNumber"}
                      direction={sortField === "policyNumber" ? sortOrder : "asc"}
                      onClick={() => handleSort("policyNumber")}
                    >
                      Policy Number
                    </TableSortLabel>
                  </TableCell>
                )}
                {visibleCols.company && (
                  <TableCell sx={{ fontWeight: "bold" }} sortDirection={sortField === "company" ? sortOrder : false}>
                    <TableSortLabel
                      active={sortField === "company"}
                      direction={sortField === "company" ? sortOrder : "asc"}
                      onClick={() => handleSort("company")}
                    >
                      Company
                    </TableSortLabel>
                  </TableCell>
                )}
                {visibleCols.effectiveDate && (
                  <TableCell sx={{ fontWeight: "bold" }} sortDirection={sortField === "effectiveDate" ? sortOrder : false}>
                    <TableSortLabel
                      active={sortField === "effectiveDate"}
                      direction={sortField === "effectiveDate" ? sortOrder : "asc"}
                      onClick={() => handleSort("effectiveDate")}
                    >
                      Effective Date
                    </TableSortLabel>
                  </TableCell>
                )}
                {visibleCols.expirationDate && (
                  <TableCell sx={{ fontWeight: "bold" }} sortDirection={sortField === "expirationDate" ? sortOrder : false}>
                    <TableSortLabel
                      active={sortField === "expirationDate"}
                      direction={sortField === "expirationDate" ? sortOrder : "asc"}
                      onClick={() => handleSort("expirationDate")}
                    >
                      Expiration Date
                    </TableSortLabel>
                  </TableCell>
                )}
                {visibleCols.status && (
                  <TableCell sx={{ fontWeight: "bold" }} sortDirection={sortField === "status" ? sortOrder : false}>
                    <TableSortLabel
                      active={sortField === "status"}
                      direction={sortField === "status" ? sortOrder : "asc"}
                      onClick={() => handleSort("status")}
                    >
                      Status
                    </TableSortLabel>
                  </TableCell>
                )}
                {visibleCols.lineOfBusiness && (
                  <TableCell sx={{ fontWeight: "bold" }} sortDirection={sortField === "lineOfBusiness" ? sortOrder : false}>
                    <TableSortLabel
                      active={sortField === "lineOfBusiness"}
                      direction={sortField === "lineOfBusiness" ? sortOrder : "asc"}
                      onClick={() => handleSort("lineOfBusiness")}
                    >
                      Line of Business
                    </TableSortLabel>
                  </TableCell>
                )}
                {visibleCols.policyType && (
                  <TableCell sx={{ fontWeight: "bold" }} sortDirection={sortField === "policyType" ? sortOrder : false}>
                    <TableSortLabel
                      active={sortField === "policyType"}
                      direction={sortField === "policyType" ? sortOrder : "asc"}
                      onClick={() => handleSort("policyType")}
                    >
                      Policy Type
                    </TableSortLabel>
                  </TableCell>
                )}
                {visibleCols.name && (
                  <TableCell sx={{ fontWeight: "bold" }} sortDirection={sortField === "name" ? sortOrder : false}>
                    <TableSortLabel
                      active={sortField === "name"}
                      direction={sortField === "name" ? sortOrder : "asc"}
                      onClick={() => handleSort("name")}
                    >
                      Name
                    </TableSortLabel>
                  </TableCell>
                )}
                {visibleCols.emailId && (
                  <TableCell sx={{ fontWeight: "bold" }} sortDirection={sortField === "emailId" ? sortOrder : false}>
                    <TableSortLabel
                      active={sortField === "emailId"}
                      direction={sortField === "emailId" ? sortOrder : "asc"}
                      onClick={() => handleSort("emailId")}
                    >
                      Email
                    </TableSortLabel>
                  </TableCell>
                )}
                {visibleCols.phoneNumber && (
                  <TableCell sx={{ fontWeight: "bold" }} sortDirection={sortField === "phoneNumber" ? sortOrder : false}>
                    <TableSortLabel
                      active={sortField === "phoneNumber"}
                      direction={sortField === "phoneNumber" ? sortOrder : "asc"}
                      onClick={() => handleSort("phoneNumber")}
                    >
                      Phone
                    </TableSortLabel>
                  </TableCell>
                )}
                {visibleCols.state && (
                  <TableCell sx={{ fontWeight: "bold" }} sortDirection={sortField === "state" ? sortOrder : false}>
                    <TableSortLabel
                      active={sortField === "state"}
                      direction={sortField === "state" ? sortOrder : "asc"}
                      onClick={() => handleSort("state")}
                    >
                      State
                    </TableSortLabel>
                  </TableCell>
                )}
                {visibleCols.premium && (
                  <TableCell sx={{ fontWeight: "bold" }} sortDirection={sortField === "premium" ? sortOrder : false}>
                    <TableSortLabel
                      active={sortField === "premium"}
                      direction={sortField === "premium" ? sortOrder : "asc"}
                      onClick={() => handleSort("premium")}
                    >
                      Premium
                    </TableSortLabel>
                  </TableCell>
                )}
              </TableRow>
            </TableHead>

            <TableBody>
              {!hasSearched ? (
              <TableRow>
                <TableCell colSpan={12} align="center">
                  Please use the filters above and click <strong>Filter</strong> to see results.
                </TableCell>
              </TableRow>
            ) : policyList.length > 0 ? (
              policyList.map((policy) =>(
                  <TableRow 
                    className="styled-table-row" 
                    key={policy.id}
                    onClick={() => handleRowClick(policy)}
                    sx={{ 
                      cursor: 'pointer',
                      '&:hover': { 
                        backgroundColor: 'rgba(0, 0, 0, 0.04)' 
                      } 
                    }}
                  >
                    {visibleCols.policyNumber && <TableCell>{policy.policyNumber}</TableCell>}
                    {visibleCols.company && <TableCell>{policy.company}</TableCell>}
                    {visibleCols.effectiveDate && <TableCell>{policy.effectiveDate}</TableCell>}
                    {visibleCols.expirationDate && <TableCell>{policy.expirationDate}</TableCell>}
                    {visibleCols.status && <TableCell>{policy.status}</TableCell>}
                    {visibleCols.lineOfBusiness && <TableCell>{policy.lineOfBusiness}</TableCell>}
                    {visibleCols.policyType && <TableCell>{policy.policyType}</TableCell>}
                    {visibleCols.name && <TableCell>{policy.firstName} {policy.middleName} {policy.lastName}</TableCell>}
                    {visibleCols.emailId && <TableCell>{policy.emailId}</TableCell>}
                    {visibleCols.phoneNumber && <TableCell>{formatPhoneNumber(policy.phoneNumber)}</TableCell>}
                    {visibleCols.state && <TableCell>{policy.state}</TableCell>}
                    {visibleCols.premium && <TableCell>{policy.premium}</TableCell>}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                <TableCell colSpan={12} align="center">
                  <NoSearchResults/>
                </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        )}
      </Box>

      {hasSearched && pagination?.totalElements > 0 && (
        <Box sx={{ width: '100%', overflow: 'hidden', padding: '16px 0' }}>
          <Stack
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
            flexWrap="wrap"
            spacing={2}
            sx={{
              '@media (max-width: 600px)': {
                flexDirection: 'column',
                alignItems: 'center',
              },
            }}
          >
            <Box display="flex" alignItems="center">
              <Typography variant="body2" sx={{ fontSize: '12px', marginRight: '8px' }}>
                Rows per page:
              </Typography>
              <Select
                value={rowsPerPage}
                onChange={(e) => {
                  setRowsPerPage(parseInt(e.target.value, 10));
                  setCurrentPage(1);
                }}
                size="small"
                sx={{ fontSize: '12px', minWidth: '80px' }}
              >
                {[5, 10, 15, 25, 50, 100].map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </Box>
            <Pagination
              count={pagination.totalPages}
              page={currentPage}
              onChange={(e, value) => setCurrentPage(value)}
              showFirstButton
              showLastButton
              siblingCount={1} 
              boundaryCount={1}
              size="small"
            />
          </Stack>
        </Box>
      )}
    </Box>
  );
};

export default PolicyList;